module.exports = "pegasus_template/assets/column-13-basic.png";